<div
  class="flex flex-col justify-between h-full text-center cover md:min-w-[600px] overflow-y-scroll m-4 md:m-0 rounded-lg md:rounded-none"
  [ngClass]="{ shown: isShown }"
>
  <mat-tab-group
    class="invisible-tabs"
    dynamicHeight
    [selectedIndex]="getSelectedIndex()"
  >
    <mat-tab label="First">
      <!-- Hero -->
      <cover-hero
        (onCloseClick)="heroOrClose()"
        (onSignupClick)="state = 'signup'"
        (onLoginClick)="state = 'login'"
      ></cover-hero>
    </mat-tab>
    <mat-tab label="Second">
      <!-- Sign up -->
      <cover-signup
        (onBackClick)="heroOrClose()"
        (onClose)="heroOrClose()"
        (onLoginClick)="state = 'login'"
      ></cover-signup>
    </mat-tab>
    <mat-tab label="Third">
      <!-- Login -->
      <cover-signup
        [isForLogin]="true"
        (onSignupClick)="state = 'signup'"
        (onLoginClick)="state = 'login'"
        (onClose)="heroOrClose()"
        (onBackClick)="heroOrClose()"
      ></cover-signup>
    </mat-tab>
  </mat-tab-group>
</div>
<div class="overlay" (click)="heroOrClose()"></div>
